import request from '@/util/request'

// 获取下拉框组织架构
export function getDeptTree (data) {
    return request({
        method: "post",
        url: '/system/dept/indexTreeselect',
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        data: {
            deptId: sessionStorage.getItem('deptId')
        }
    })
}
